import { useEffect, useRef } from "react";
import { getOrder } from "@/lib/orderApi";
import { retireEndedAggregates } from "@/lib/captainMesh/db";

const EVERY_MS = 20_000;

/**
 * Keep this device's offline copies in step with tables another device ended
 * (owner, 2026-10-24: a cancelled table still showed as occupied on one or two
 * phones). Runs when the live board has loaded, then at most every 20 s as it
 * changes. A failure is logged and retried on the next board change; it never
 * touches the screen.
 */
export function useRetireEndedTables(restOrders, loaded, token) {
  const last = useRef(0);
  const latest = useRef(restOrders);
  latest.current = restOrders;
  useEffect(() => {
    if (!loaded || !token) return undefined;
    const run = () => {
      last.current = Date.now();
      retireEndedAggregates({
        boardOrderIds: (latest.current || []).map(order => order.id),
        fetchOrder: id => getOrder(id, token),
      }).catch(failure => console.warn("[mesh] checking ended tables failed", failure));
    };
    // Throttled, never dropped: a change inside the 20 s window runs when the
    // window ends (review, 2026-10-24: a skipped run left a ghost table).
    const wait = Math.max(0, EVERY_MS - (Date.now() - last.current));
    const timer = setTimeout(run, wait);
    return () => clearTimeout(timer);
  }, [restOrders, loaded, token]);
}
